export default {"src":"/_next/static/media/PC_PoweredBy_White_1.4f9e01a7.svg","height":206,"width":891,"blurWidth":0,"blurHeight":0};